// DO NOT INCLUDE v11

import Debugger from 'play_perfect/Debugger'
window.debug = Debugger.build(window.readCookie('debug'), window)

require('play_perfect/wasm/glue')

/*
import CardUtil from 'play_perfect/CardUtil'
window.CardUtil = CardUtil
*/

import VPMachine from 'play_perfect/VPMachine'
window.VPMachine = VPMachine

/*
import Game from 'play_perfect/Game'
window.Game = Game

import Hand from 'play_perfect/Hand'
window.Hand = Hand

import State from 'play_perfect/State'
window.State = State

import Results from 'play_perfect/Results'
window.Results = Results

import HandDisplay from 'play_perfect/HandDisplay'
window.HandDisplay = HandDisplay
*/


import Evaluator from 'play_perfect/Evaluator'
window.Evaluator = Evaluator

// import Control from 'play_perfect/EvaluateControl'
// window.Control = Control